import { AaasFeaturePermission } from '@va/aaas/shared/types';
import { apiGateway } from '@va/api-client';
import { getAccessToken } from '@va/standalone/shared/helpers';

export const fetchFeaturePermissions = async (websiteId: string): Promise<AaasFeaturePermission[]> => {
  const res = await apiGateway.get(`v2/websites/${websiteId}/feature-permissions`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });

  return res.payload;
};
